import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import { BizAppConfig } from 'config/application.manifest';

const request = createAppRequest();

export interface AuthorizedResourceAction {
  name: string;
  description?: string;
}

export interface AuthorizedResource {
  effect?: string;
  code: string;
  type?: string;
  condition?: unknown;
  description?: string | null;
  actions?: string[];
  apiIdentifier?: string | null;
  namespaceId?: number | null;
}

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  return request<AuthorizedResource[]>(BizAppConfig.appTenantManagementUrl + `bff/permission/me/authorized-resources`, {
    method: 'GET',
    params: { appId },
    ...(options || {}),
  });
}
